module.exports = __webpack_public_path__ + "media/images/iconEdit__okGreen-ee1822554965a7878c944ce23ba57236.png";